<template>
    <v-app id="login">
        <v-main>
            <!--<select-locale fixed top right></select-locale>-->
            <v-container fluid class="fill-height">
                <v-row align="center" justify="center" >
                    <v-col cols="12" sm="8" md="4">
                        <password-recover v-if="isRecover" @back="setTab('login')" />
                        <password-reset v-else-if="isPasswordChange" :token="data.token" :email="data.email"></password-reset>
                        <register
                                v-else-if="isRegister"
                                @back="setTab('login')"
                                @registered="onRegister"
                                ></register>
                        <verify
                                v-else-if="isVerify"
                                :action="action"
                                ></verify>
                        <confirm
                                v-else-if="isConfirm"
                                :action="action"
                                :reset-password="resetPassword"
                                ></confirm>
                        <login v-else
                               :allow-registration="allowRegistration"
                               @logged="onLogin"
                               @password-reset="setTab('recover')"
                               @register="setTab('register')"
                                ></login>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
import Login from "./Auth/Login";
import PasswordRecover from "./Auth/PasswordRecover";
import PasswordReset from "./Auth/PasswordReset";
import Register from "./Auth/Register";
import Verify from "./Auth/Verify";
import Confirm from "./Auth/Confirm";

export default {
        name:'auth-layout',
        props: {
            allowRegistration:{type:Boolean,default:true},
            data:{type:Object,required:false,default(){return{};}},
            value:{type:String,default:'login',},
            action:{type:String,default:undefined,},
            resetPassword:{type:String,default:null,},
        },
        data() {
            return {
                activeTab:this.value,
            }
        },
        mounted() {
        },
        computed: {
            isRecover(){return this.activeTab==='recover'||this.activeTab==='password-recovery';},
            isPasswordChange(){return this.activeTab==='password-reset';},
            isRegister(){return this.activeTab==='register';},
            isVerify(){return this.activeTab==='verify';},
            isConfirm(){return this.activeTab==='confirm';},
        },
        methods: {
            setTab(v){
                this.activeTab=v;
                this.$emit(v);
            },
            onLogin(data){
                location.href = data.redirect;
            },
            onRegister(data){
                location.href = data.redirect;
            }
        },
        watch:{
            value(v,oldv){this.activeTab=v;}
        },
        components: {
            Login,
            PasswordRecover,
            PasswordReset,
            Register,
            Verify,
            Confirm,
        },
        filters: {}
    }
</script>
